window.mtcImageTags = function mtcImageTags(tag_trigger, tag_container) {
    "use strict";

    $(tag_trigger).on('click', function () {
        var $this = $(this),
            this_tag = $this.next(tag_container);

        if($(this).hasClass('active')) {
            this_tag.stop(true, true).fadeOut();
            $this.removeClass('active');
        } else {

            // handle fade in/out and add/remove appropriate class
            $('.imageTag').stop(true, true).fadeOut();
            $('.imageTagTrigger').removeClass('active');

            // handle fade in/out and add/remove appropriate class
            this_tag.stop(true, true).fadeIn();
            $this.addClass('active');
        }


        // allow the box inside to be interacted with
        this_tag.on('click', function (e) {
            e.stopImmediatePropagation();
        });
    });

    $('.closeMe').on('click', function() {
        $(this).parents('.imageTag').fadeOut();
        $(this).parents('.imageTag').prev().removeClass('active');
    })

    // hide tags if anything else is clicked
    $(document).on('click', function (e) {
        if (!$(e.target).closest(tag_trigger).length) {
            $(tag_trigger).removeClass('active').next(tag_container).fadeOut();
        }
    });
}

$(document).ready(function () {
    "use strict";

    mtcImageTags('.js_imageTagTrigger', '.js_imageTag');
});